import { AfterViewInit, Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseComponent } from '@ids-components';
import { ASSESSMENT_REPORT_STATUS, ASSESSMENT_STATUS } from '@ids-constants';
import { AssessmentService } from '@ids-services';
import { CardComponent, LoadingOverlayComponent, SelectedPanelHeaderComponent } from '@microsec/components';
import { authenticationSelectors } from '@microsec/ngrx-authentication';
import { ButtonModule } from 'primeng/button';
import { TabsModule } from 'primeng/tabs';
import { TooltipModule } from 'primeng/tooltip';
import { finalize, firstValueFrom } from 'rxjs';
import { AssessmentOverviewComponent } from './assessment-overview/assessment-overview.component';
import { SharedAssessmentDevicesComponent } from '../../../../../../shared-components/shared-assessment-devices/shared-assessment-devices.component';

@Component({
  selector: 'app-assessment-details',
  templateUrl: './assessment-details.component.html',
  styleUrls: ['./assessment-details.component.scss'],
  imports: [
    ButtonModule,
    TooltipModule,
    TabsModule,
    LoadingOverlayComponent,
    CardComponent,
    SelectedPanelHeaderComponent,
    AssessmentOverviewComponent,
    SharedAssessmentDevicesComponent,
  ],
})
export class AssessmentDetailsComponent extends BaseComponent implements AfterViewInit {
  @Input() isLoading = false;

  _assessment = null;

  get assessment() {
    return this._assessment;
  }

  @Input() set assessment(value: any) {
    this._assessment = value;
    this.getAssessmentDetails();
  }

  @Output() assessmentChange = new EventEmitter<any>();

  @Output() hideDetailsPanelEvent = new EventEmitter<any>();

  @Output() executeEvent = new EventEmitter<any>();

  @Output() openAssessmentFormEvent = new EventEmitter<any>();

  @Output() openDeleteConfirmationEvent = new EventEmitter<any>();

  @Output() openAssessmentReportEvent = new EventEmitter<any>();

  currentUser: any = null;

  devices: any[] = [];

  ASSESSMENT_STATUS = ASSESSMENT_STATUS;

  ASSESSMENT_REPORT_STATUS = ASSESSMENT_REPORT_STATUS;

  constructor(private assessmentSrv: AssessmentService) {
    super();
  }

  async ngAfterViewInit() {
    await this.prepareConfigs();
    this.currentUser = await firstValueFrom(this.store.select(authenticationSelectors.currentUser));
  }

  getAssessmentDetails() {
    this.isLoading = true;
    this.assessmentSrv
      .getAssessment(this.assessment?.id)
      .pipe(
        finalize(() => {
          this.isLoading = false;
        }),
      )
      .subscribe({
        next: (rs) => {
          this.devices = (rs.devices as any[]) || [];
        },
        error: (err) => {
          this.showErrorMessage(err);
        },
      });
  }

  hideDetailsPanel(evt?: any) {
    this.hideDetailsPanelEvent.emit(evt);
  }

  execute() {
    this.executeEvent.emit(this.assessment);
  }

  openAssessmentForm() {
    this.openAssessmentFormEvent.emit(this.assessment);
  }

  openDeleteConfirmation() {
    this.openDeleteConfirmationEvent.emit([this.assessment]);
  }

  openAssessmentReport() {
    this.openAssessmentReportEvent.emit(this.assessment);
  }
}
